export default "__VITE_ASSET__8639$BTZ__"